import React from "react";
import useUniqueId from "./useUniqueId";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const InfoIcon: React.FC<{text: string}> = props => {

    const id = useUniqueId();

    if (props.text == null || props.text.length === 0) return <></>;

    return <OverlayTrigger 
        placement="auto"
        trigger="click" 
        rootClose
        overlay={<Tooltip id={id}>{props.text}</Tooltip>}>
        <i className="fa fa-info-circle p-2 clickable"></i>
    </OverlayTrigger>;
}

export default InfoIcon